export default "<canvas id='gif-draw-canvas' :width='gifWidth' :height='gifHeight'></canvas>";